// extracted by mini-css-extract-plugin
export var link = "_ug-0";